import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-console',
  templateUrl: './site-console.component.html',
  styleUrls: ['./site-console.component.css']
})
export class SiteConsoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
